import { DateTime } from 'luxon';

export function dateOrTime(date: DateTime | string) {
  const dateTime = typeof date === 'string' ? DateTime.fromISO(date) : date;
  if (dateTime.diffNow().as('days') > -1) {
    return dateTime.toLocaleString(DateTime.TIME_SIMPLE);
  }
  return dateTime.toFormat('MMM dd');
}
